import React from "react";

const About = () => {
    return (
        <div className="mt-5 pt-5">
            <div className="container mt-5 mb-2">
                <div className="text-center">
                    <h1 className="search-text">
                        About
                        <span className="search-heading-text"> Us</span>
                    </h1>
                    <hr />
                </div>
            </div>
            <div className="container mt-5 mb-2">
                <div className="text-center">
                    <h1 className="search-text">
                        Travel Agency
                        <span className="search-heading-text"> Story</span>
                    </h1>
                    <p className="w-50 mx-auto fw-medium p-3">
                        Enthusiastically mesh long-term high-impact
                        infrastructures vis-a-vis efficient customer service.
                        Professionally fashion wireless leadership rather than
                        prospective experiences.
                    </p>
                    <p className="w-75 mx-auto fw-medium p-3">
                        Quickly aggregate B2B users and worldwide
                        potentialities. Progressively plagiarize
                        resource-leveling e-commerce through resource-leveling
                        core competencies. Dramatically mesh low-risk high-yield
                        alignments before transparent e-tailers. Appropriately
                        empower dynamic leadership skills after business
                        portals. Globally myocardinate interactive supply chains
                        with distinctive quality vectors. Globally revolutionize
                        global sources through interoperable services.
                        Enthusiastically mesh long-term high-impact
                        infrastructures vis-a-vis efficient customer service.
                        Professionally fashion wireless leadership rather than
                        prospective experiences. Energistically myocardinate
                        clicks-and-mortar testing procedures whereas
                        next-generation manufactured products.
                    </p>
                </div>
            </div>

            <div className="container mt-5 mb-2">
                <div className="text-center">
                    <h1 className="search-text">
                        Our
                        <span className="search-heading-text"> Mission</span>
                    </h1>
                    <p className="w-50 mx-auto fw-medium p-3">
                        Dynamically reinvent market-driven opportunities and
                        ubiquitous interfaces. Energistically fabricate an
                        expanded array of niche markets through robust strategic
                        web-readiness.
                    </p>
                    <p className="w-75 mx-auto fw-medium p-3">
                        Compellingly embrace empowered e-business after user
                        friendly intellectual capital. Interactively actualize
                        front-end processes with effective convergence.
                        Synergistically deliver performance based methods of
                        empowerment whereas distributed expertise. Efficiently
                        enable enabled sources and cost effective products.
                        Completely synthesize principle-centered information
                        after ethical communities. Efficiently innovate
                        open-source infrastructures via inexpensive materials.
                        Objectively integrate enterprise-wide strategic theme
                        areas with functionalized infrastructures. Interactively
                        productize premium technologies whereas interdependent
                        quality vectors. Rapaciously utilize enterprise
                        experiences via 24/7 markets.
                    </p>
                </div>
            </div>

            <div className="container mt-5 mb-2">
                <div>
                    <h5 className="text-center">DEDICATED TOUR GUIDES</h5>
                    <h1 className="search-text text-center">
                        Travel Agency
                        <span className="search-heading-text"> Team</span>
                    </h1>
                    <p className="w-50 mx-auto fw-medium p-3">
                        Completely pursue scalable customer service through
                        sustainable potentialities. Holistically pontificate
                        installed base portals. Dynamically innovate
                        resource-leveling customer service.
                    </p>
                    <div className="row row-cols-lg-3 gx-5">
                        <div className="col">
                            <div className="card">
                                <img
                                    src="http://travelicious.bold-themes.com/main-demo/wp-content/uploads/sites/2/2018/09/people-03.jpg"
                                    className="card-img-top w-full p-0"
                                    alt="..."
                                />
                                <div className="card-body">
                                    <h5 className="card-title">Emma Nielsen</h5>
                                    <p className="card-text">
                                        Enthusiastically mesh long-term
                                        high-impact infrastructures vis-a-vis
                                        efficient customer service.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="card">
                                <img
                                    src="http://travelicious.bold-themes.com/main-demo/wp-content/uploads/sites/2/2018/09/people-01.jpg"
                                    className="card-img-top w-full p-0"
                                    alt="..."
                                />
                                <div className="card-body">
                                    <h5 className="card-title">Adil Rasid</h5>
                                    <p className="card-text">
                                        Objectively integrate enterprise-wide
                                        strategic theme areas with
                                        functionalized infrastructures.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col">
                            <div className="card">
                                <img
                                    src="http://travelicious.bold-themes.com/main-demo/wp-content/uploads/sites/2/2018/09/people-04.jpg"
                                    className="card-img-top w-full p-0"
                                    alt="..."
                                />
                                <div className="card-body">
                                    <h5 className="card-title">Quic Jhon</h5>
                                    <p className="card-text">
                                        Professionally fashion wireless
                                        leadership rather than prospective
                                        experiences.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
